import * as yup from "yup";
import { pathSchema } from "features/Path/schema";
import { trigger } from "features/Trigger/TemplateTrigger/Form/schema";
import { EmailRecipient } from "../Email/models/EmailRecipient";

export const emailTemplateSchema = yup.object({
  pathIds: yup.array().of(yup.string().required()).optional().default([]),
  paths: yup.array().of(pathSchema).optional().default([]),
  name: yup.string().required().label("Title").max(70, "Title cannot be more than 70 characters"),
  to: yup.array().of(yup.mixed<EmailRecipient>().defined()).optional().label("To")
    .test(
      "at-least-one",
      "At least one recipient is required for To, Cc, or Bcc",
      (value, testContext) => {
        const { parent } = testContext;

        if (!parent) return true;

        const has = (arr?: EmailRecipient[]) => Array.isArray(arr) && arr.length > 0;
        return has(value) || has(parent.cc) || has(parent.bcc);
      },
    ),
  cc: yup.array().of(yup.mixed<EmailRecipient>().defined()).optional().label("Cc"),
  bcc: yup.array().of(yup.mixed<EmailRecipient>().defined()).optional().label("Bcc"),
  deliverAtTrigger: trigger.required().label("Send At"),
  subject: yup.string().required().label("Subject"),
  body: yup.string().required().label("Body"),
  allowWeekends: yup.boolean().optional().default(false).label("Allow Weekends"),
});

export type EmailTemplateSchema = yup.InferType<typeof emailTemplateSchema>;

/**
 * NOTE: This schema type may include form-specific fields (like 'paths') that aren't sent to the API.
 * Use toCreateEmailTemplatePayload() or toUpdateEmailTemplatePayload() from ./helpers
 * to transform form data into the correct API payload structure.
 */
